import { render } from "./EditDispatchModal2.vue?vue&type=template&id=3f7e76c5&scoped=true"
import script from "./EditDispatchModal2.vue?vue&type=script&lang=js"
export * from "./EditDispatchModal2.vue?vue&type=script&lang=js"

import "./EditDispatchModal2.vue?vue&type=style&index=0&id=3f7e76c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7e76c5"]])

export default __exports__